import { Married } from "./v1";

export type MarriedV1Type = keyof typeof Married;
export type MarriedType = MarriedV1Type;
